import { axiosInstance } from "./axiosConfig";
import { isAxiosError } from "axios";

// INTERFACE_MEDICAL_CARD
interface MedicalCard {
    insurer_name: string;
    policy_number: string;
    insured_company_name: string;
    insured_person_name: string;
    insured_person_birth_date: string;
    insured_person_pin: string;
    insured_person_mobile_number: string;
    medical_insurance_program: string;
    start_date: string;
    end_date: string;
    status: 'Active' | 'Inactive' | 'Expired';
    call_center_number: string;
    emergency_call_number: string;
    medical_coverages: string[];
}

// INTERFACE_SUCCESS_RESPONSE
interface MedicalCardSuccessResponse {
    data: MedicalCard;
    message?: string;
}

// VALIDATION_ERROR
interface ErrorDetail {
    code: string;
    detail: string;
    attr: string;
}

// GENERIC_ERROR_RESPONSE
interface GenericErrorResponse {
    error?: string;
}

// INTERFACE_ERROR_RESPONSE
interface MedicalCardErrorResponse {
    type: 'validation_error';
    errors: ErrorDetail[];
}

// INTERFACE_RESULT
interface MedicalCardResult {
    data: MedicalCardSuccessResponse | MedicalCardErrorResponse | GenericErrorResponse;
    status: number;
}

// GET MEDICAL CARD API
export const GetMedicalCard = async (
    language: 'az' | 'en' = 'az'
): Promise<MedicalCardResult> => {
    try {
        const response = await axiosInstance.get<MedicalCardSuccessResponse>(
            '/health/medical-cards',
            {
                headers: {
                    'Accept-Language': language,

                }
            }
        );

        return {
            data: response.data,
            status: response.status
        };

    } catch (error) {
        if (isAxiosError(error)) {
            // HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status
                };
            }

            // Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0
                };
            }
        }

        // Another error
        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1
        };
    }
};